import { useQuery } from 'react-query';
import useContext from '../../hooks/useContext';
import { SiteContext } from '../../SiteContext';
import { get } from '../fetch';

export const useGetSimilarVariantsInStock = (groupId: string, storeId?: string) => {
  const {
    data: { searchServiceUrl },
  } = useContext(SiteContext);

  return useQuery(
    ['SimilarVariantsInStock', groupId, storeId],
    () =>
      get<IOptionResponse[]>(
        `${searchServiceUrl}/product/contiguous-in-stock?id=${groupId}&store=${storeId}&useMetaData=true`,
      ),
    {
      enabled: !!storeId && !!groupId,
    },
  );
};

export const useGetStoreStocksByGroupId = (groupId: string) =>
  useQuery(
    ['variantsInStoreStockByGroupId', groupId],
    () => get<Record<string, number>>(`/bff/api/stock/variants-in-stock?groupId=${groupId}`),
    {
      enabled: !!groupId,
    },
  );
